import * as React from 'react';
import {Outlet} from 'react-router';

import {BannerLayout} from 'common/report/layout/banner-layout/index';

export const BannerLayoutOutlet: React.FC = () => {
  return (
    <BannerLayout>
      <Outlet />
    </BannerLayout>
  );
};
// eslint-disable-next-line import/no-default-export
export default BannerLayoutOutlet;
